import React from 'react';
import PropTypes from 'prop-types';

import './RankingButton.scss';

const RankingButton = ({
    buttonLabel,
    icon: Icon,
    type,
    isActive,
    setSort,
    closeDropdown,
}) => {
    const activeStyle = isActive ? 'active' : '';

    const setSortType = () => {
        setSort(type);
        closeDropdown();
    };

    return (
        <>
            <div
                className="component-RankingButton"
                onClick={setSortType}
                onKeyPress={setSortType}
                role="button"
                tabIndex={0}
            >
                <Icon isActive={isActive} />
                <span className={`rankingButton-label ${activeStyle}`}>
                    {buttonLabel}
                </span>
            </div>
        </>
    );
};

RankingButton.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    icon: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    setSort: PropTypes.func.isRequired,
    closeDropdown: PropTypes.func.isRequired,
};

RankingButton.defaultProps = {
    isActive: false,
};

RankingButton.displayName = 'RankingButton';

export default RankingButton;
